<template>
  <div class="invoices col-sm-12">
    <Loader v-if="!resourceLoaded" />
    <SendInvoiceModal
      ref="sendInvoiceModalDetails"
      id="send-invoice-modal-details"
    />
    <div class="panel" v-if="resourceLoaded">
      <div class="panel-body bg-white">
        <div id="container">
          <div id="content" class="main-content invoice-content">
            <div class="container-fluid">
              <div class="invoice_page invoice-margin">
                <!--invoice address area start-->
                <div class="invoice_info clearfix">
                  <div class="info_left">
                    <div class="row">
                      <div class="col-lg-3 col-md-3 col-sm-6 col-12">
                        <div class="info_address">
                          <h5>
                            <strong>
                              {{ invoice.owner.first_name }}
                              {{ invoice.owner.last_name }}
                            </strong>
                          </h5>
                          <h5>
                            <strong
                              >{{
                                $t("booking.detail.invoices.email")
                              }} </strong
                            ><span>{{ invoice.owner.email }}</span>
                          </h5>
                          <h5>
                            <strong
                              >{{
                                $t("booking.detail.invoices.phone")
                              }} </strong
                            ><span>{{ invoice.owner.phone }}</span>
                          </h5>
                          <h5>
                            <strong
                              >{{
                                $t("booking.detail.invoices.address")
                              }} </strong
                            ><span
                              >{{ invoice.owner.address }} {{ invoice.owner.city }}
                              {{ invoice.owner.country }}</span
                            >
                          </h5>
                        </div>
                      </div>
                      <div
                        class="col-lg-3 offset-lg-3 col-md-3 offset-md-3 col-sm-6 col-12"
                      >
                        <div class="info_date clearfix">
                          <p>
                            {{ $t("booking.detail.invoices.status") }}
                            <span>{{
                              invoice.status == "paid"
                                ? $t("booking.detail.paid")
                                : $t("booking.detail.unpaid")
                            }}</span>
                          </p>
                          <div class="clear"></div>
                        </div>
                      </div>
                      <div class="col-lg-3 col-md-3 col-sm-6 col-12">
                        <div class="info_right invoice-info">
                          <div class="info_num">
                            <div class="info_address">
                              <h5>
                                <strong>#{{ invoice.invoice_number }}</strong>
                              </h5>
                              <p>
                                {{ user.first_name + " " + user.last_name
                                }}<br />{{ user.email }} <br />
                                {{ user.address }} <br />
                                {{ user.city }} <br />
                                {{ user.country }} <br />
                                {{ user.phone }} <br />
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--invoice address area end-->
                <!--invoice details table area start-->
                <div class="invoice_details">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="table-responsive">
                        <table class="table">
                          <thead>
                          <tr>
                            <th>
                              {{ $t("booking.detail.invoices.description") }}
                            </th>
                            <th style="width: 150px">
                              {{ $t("booking.detail.invoices.amount") }}
                            </th>
                            <th style="width: 100px">
                              {{ $t("booking.detail.invoices.vat") }} &#37;
                            </th>
                            <th style="width: 200px" class="line-total">
                              {{ $t("booking.detail.invoices.line_total") }}
                            </th>
                          </tr>
                          </thead>
                          <tbody
                            v-for="booking of invoice.rows.filter(i => i.type === 'summary' || i.type === 'custom')"
                            :key="booking.id"
                            style="display: table-row-group"
                          >
                          <tr>
                            <td>
                              <div
                                v-if="booking.type === 'custom'"
                                class="delete-invoice"
                                @click.prevent="removeRow(booking.id)"
                              >
                                <i class="icon md-close" ></i>
                              </div>
                              <div class="invoice-rental">
                                  <span class="tl"
                                  >{{
                                      $t("booking.detail.invoices.description")
                                    }}
                                    <i
                                      class="icon md-star"
                                      aria-hidden="true"
                                    ></i
                                    ></span>
                                <div class="row">
                                  <div class="col-sm-12">
                                    <div class="form-group form-material">
                                      <input
                                        type="text"
                                        class="form-control"
                                        v-model="booking.description"
                                        :disabled="booking.type != 'custom'"
                                        required
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td style="width: 150px">
                                <span class="tl"
                                >{{ $t("booking.detail.invoices.amount") }}
                                  <i class="icon md-star" aria-hidden="true"></i
                                  ></span>
                              <div class="row">
                                <div class="col-sm-12">
                                  <div class="form-group form-material">
                                    <div
                                      class="input-group"
                                      style="max-width: 150px"
                                    >
                                      <input
                                        type="number"
                                        min="0"
                                        step="0.01"
                                        class="form-control"
                                        v-model="booking.amount"
                                        :disabled="booking.type != 'custom'"
                                        required
                                      />
                                      <span class="input-group-addon">{{
                                          currency
                                        }}</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td>
                                <span class="tl"
                                >{{ $t("booking.detail.invoices.vat") }}
                                  <i class="icon md-star" aria-hidden="true"></i
                                  ></span>
                              <div class="row">
                                <div class="col-sm-12">
                                  <div class="form-group form-material">
                                    <div
                                      class="input-group"
                                      style="max-width: 100px"
                                    >
                                      <input
                                        type="number"
                                        min="0"
                                        step="1"
                                        class="form-control"
                                        v-model="booking.vat"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td class="total" style="width: 150px">
                                <span class="total_value">
                                  {{ booking.total }} {{ currency }}</span
                                >
                            </td>
                          </tr>
                          </tbody>
                        </table>

                      </div>
                    </div>
                  </div>
                </div>
                <!--invoice details table area end-->
                <div class="invoice_total">
                  <p>
                    <span>
                      {{ $t("booking.detail.invoices.invoice_total") }} </span
                    >{{ parseFloat(invoice.total).toFixed(2) }} {{ currency }}
                  </p>
                </div>
                <div class="mt-4">
                  <button
                    type="button"
                    data-toggle="dropdown"
                    class="btn btn-secondary waves-effect waves-classic btn-with-caret"
                    aria-expanded="false"
                    @click.prevent="addRow()"
                  >
                    {{ $t("superconcierge.invoice.add_row") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import superconciergerie from "../../../services/superconciergerie";
export default {
  data() {
    return {
      resourceLoaded: false,
      user: {},
      invoice: {},
      settings: {},
      currency: "€",
    };
  },
  methods: {
    async addRow() {
      this.invoice.rows.push({
        id: "custom_" + Math.random().toString(36).substring(7),
        description: "",
        amount: 0,
        vat: this.settings.vat,
        type: 'custom'
      });
    },
    async removeRow(rowId) {
      // remove invoice.rows id
      this.invoice.rows = this.invoice.rows.filter((item) => item.id !== rowId);
    },
    async openBooking(bookingId) {
      window.open(
        "/#/bookings/" + bookingId + "/informations",
        "_blank"
      );
    },
    async save() {
      await superconciergerie.updateInvoice(this.invoice, this);
    },
    async preview() {
      window.open(
        "/#/superconcierge-invoice/" + this.invoice.permalink,
        "_blank"
      );
    },
    async send() {
      // await superconciergerie.sendInvoice(this.$route.params.id)
      this.$refs.sendInvoiceModalDetails.open(
        this.$route.params.ownerId,
        this.$route.params.month,
        this.$route.params.year,
        this.$route.params.type
      );
    },
    async reset() {
      await superconciergerie.resetInvoice(
        this.$route.params.ownerId,
        this.$route.params.month,
        this.$route.params.year,
        this.$route.params.type,
        this
      );
      await this.loadResource(true);
    },
    goToPreview(ownerId, month, year) {
      // location.href = '/invoices/' + ownerId + '/' + month + '/' + year + '/preview'
    },
    async loadResource(force = false) {
      if (this.activeTab === "invoice" && (!this.resourceLoaded || force)) {
        await superconciergerie.getInvoice(
          this.$route.params.ownerId,
          this.$route.params.year,
          this.$route.params.month,
          this
        );
        this.resourceLoaded = true;
      }
    },
  },
  props: ["activeTab"],
  async mounted() {
    await this.loadResource();
  },
  watch: {
    "invoice.rows": {
      handler: function (val, oldVal) {
        this.invoice.total = 0;
        for(const row of this.invoice.rows) {
          if(row.type != 'custom' && row.type != 'summary'){
            continue;
          }
          const amount = parseFloat(row.amount);
          const vat = parseFloat(row.vat);
          if(isNaN(amount) || isNaN(vat)) {
            continue;
          }
          row.total = (amount + (amount * vat) / 100).toFixed(2);
          this.invoice.total = this.invoice.total + parseFloat(row.total);
        }
        if(isNaN(this.invoice.total)) {
          this.invoice.total = 0
        } else{
          this.invoice.total = this.invoice.total.toFixed(2);
        }
      },
      deep: true,
    },
    activeTab: {
      handler: async function (val, oldVal) {
        this.loadResource();
      },
    },
  },
  components: {
    SendInvoiceModal: require("./../modals/sendInvoiceModal.vue"),
    Loader: require('../components/Loader.vue'),
  },
};
</script>



// WEBPACK FOOTER //
// InvoiceTab.vue?ac15c2ee